var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import nem from 'nem-sdk';
import localForage from 'localforage';
import nemWrapper from './nemWrapper';
//import axios from 'axios';
import helper from './helper';
// EndpointをTestnetに指定します
// 第1引数はTestnet用のデフォルトのノード
// 第2引数はデフォルトのポート(7890)
var mosaicTransfer = /** @class */ (function () {
    function mosaicTransfer() {
        var _this = this;
        this.endpoint = '';
        this.address = '';
        this.toAddress = '';
        this.sendAmount = 0;
        this.sendMsg = '';
        this.password = '';
        this.publicKey = '';
        this.privateKey = '';
        this.common = '';
        this.yourMosaicNamespace = '';
        this.yourMosaicName = '';
        this.company_code = 0;
        this.minimum_unit = 25;
        this.working_hour_per_day = 8;
        this.approval_flag = 1;
        this.carry_over_flag = 1;
        this.show_kurikoshi = false;
        this.approval = false;
        this.nonapproval = false;
        this.host = '';
        this.port = '';
        this.net = '';
        this.nem = new nemWrapper();
        this.helper = new helper();
        // NIS設定.
        this.load()
            .then(function (result) {
            console.log(result);
            // 無ければアカウントを作成します
            if (result === null) {
                _this.nem.createAccount()
                    .then(function (wallet) {
                    _this.address = wallet.address;
                    _this.privateKey = wallet.privateKey;
                }).catch(function (error) {
                    console.error(error);
                });
            }
            else {
            }
        }).catch(function (error) {
            console.error(error);
        });
        this.host = 'https://nem02.neluta.win';
        this.port = '7891';
        //this.host = 'http://go.nem.ninja'
        //this.port = '7890'
        this.net = nem.model.network.data.mainnet.id;
        this.endpoint = nem.model.objects.create("endpoint")(this.host, this.port);
        // TODO: 自分の送金したい先のアドレスに変更してください
        // 送金先のアドレス  
        this.sendAmount = 1;
        // 送金の際に指定するメッセージ（空文字でも可）
        this.sendMsg = 'テスト私用のため';
        // TODO: 自分の送金元ウォレットのパスワードを入力してください
        // 送金元ウォレットのパスワード
        var password = 'wallet';
        //const privateKey = this.privateKey
        //const　common = nem.model.objects.create('common')(password, privateKey)
        // TODO: 送りたいモザイクのネームスペースを入力してください
        // ネームスペース
        this.yourMosaicNamespace = 'smart-uq';
        // TODO: 送りたいモザイクのモザイク名を入力してください
        // モザイク名
    }
    mosaicTransfer.prototype.sendMosaics = function (privateKey, toAmount, mosaic_message, date, amount_hd, post_message, networkTimestamp) {
        return __awaiter(this, void 0, void 0, function () {
            var host, port, net, endpoint, toAddress, password, privatekey, sendAmount, yourMosaicNamespace, yourMosaicName, common, transferTransaction, xemMozaic, yourMosaic, mosaicDefinitionMetaDataPair;
            var _this = this;
            return __generator(this, function (_a) {
                //privateKey,toAmount,massage,date,amount_hd,message
                console.log(nem.model.nodes.defaultTestnet);
                console.log(nem.model.network.data.mainnet.id);
                host = 'https://nem02.neluta.win';
                port = '7891';
                net = nem.model.network.data.mainnet.id;
                endpoint = nem.model.objects.create('endpoint')(host, port);
                console.log(endpoint);
                toAddress = this.toAddress;
                password = 'wallet';
                privatekey = privateKey;
                sendAmount = toAmount;
                yourMosaicNamespace = this.yourMosaicNamespace;
                yourMosaicName = this.yourMosaicName;
                common = nem.model.objects.create('common')("wallet", privatekey);
                console.log("common: ");
                console.log(common);
                transferTransaction = nem.model.objects.create('transferTransaction')(toAddress, sendAmount, mosaic_message);
                xemMozaic = nem.model.objects.create('mosaicAttachment')('nem', 'xem', 0 * 1000000);
                transferTransaction.mosaics.push(xemMozaic);
                yourMosaic = nem.model.objects.create('mosaicAttachment')(yourMosaicNamespace, yourMosaicName, 1);
                transferTransaction.mosaics.push(yourMosaic);
                console.log("PUSHmosaic" + yourMosaic);
                mosaicDefinitionMetaDataPair = nem.model.objects.get('mosaicDefinitionMetaDataPair');
                console.log("モザイクの定義を取得する");
                nem.com.requests.namespace.mosaicDefinitions(endpoint, yourMosaic.mosaicId.namespaceId).then(function (res) {
                    // モザイク定義を取得してモザイク定義オブジェクトへ格納する
                    console.log("モザイク定義を取得してモザイク定義オブジェクトへ格納する");
                    var neededDefinition = nem.utils.helpers.searchMosaicDefinitionArray(res.data, [yourMosaicName]);
                    console.log("neededDefinition" + neededDefinition);
                    // モザイク定義オブジェクトで使用するため、モザイクの名前を取得
                    var fullMosaicName = nem.utils.format.mosaicIdToName(yourMosaic.mosaicId);
                    console.log("fullMosaicName: " + fullMosaicName);
                    // モザイクの存在確認
                    if (undefined === neededDefinition[fullMosaicName]) {
                        return console.log('Mosaic not found !');
                    }
                    console.log("モザイクの存在確認OK");
                    console.log("adress: " + toAddress);
                    // モザイクの定義をモザイク定義オブジェクトへ追加する
                    mosaicDefinitionMetaDataPair[fullMosaicName] = {};
                    mosaicDefinitionMetaDataPair[fullMosaicName].mosaicDefinition = neededDefinition[fullMosaicName];
                    console.log("オブジェクト追加完了");
                    nem.com.requests.mosaic.supply(endpoint, fullMosaicName).then(function (supplyRes) {
                        // 供給量をmosaicDefinitionMetaDataPairに設定する。
                        console.log("供給量をmosaicDefinitionMetaDataPairに設定する。");
                        mosaicDefinitionMetaDataPair['nem:xem'].supply = 8999999999;
                        mosaicDefinitionMetaDataPair[fullMosaicName].supply = supplyRes.supply;
                        // 1. まず、SDKに通常通りトランザクションエンティティを作成させる
                        var transactionEntity = nem.model.transactions.prepare('mosaicTransferTransaction')(common, transferTransaction, mosaicDefinitionMetaDataPair, nem.model.network.data.mainnet.id);
                        // 2. ネットワーク時刻から、正しいタイムスタンプとデッドラインを計算する
                        var timeStamp = Math.floor(networkTimestamp / 1000);
                        var deadline = timeStamp + 3600;
                        // 3. prepare後に、作成されたエンティティの間違ったタイムスタンプを、正しい値で「上書き」する
                        transactionEntity.timeStamp = timeStamp;
                        transactionEntity.deadline = deadline;
                        console.log("署名をしてTransactionを送信する準備を完了");
                        // 4. 正しいタイムスタンプに書き換えたエンティティをネットワークに送信する
                        nem.model.transactions.send(common, transactionEntity, endpoint).then(function (sendRes) {
                            console.log('sendRes:', sendRes);
                            if (sendRes.message == "SUCCESS") {
                                console.log("SUCCESS");
                                if (date == '') {
                                    alert("送信成功しました。");
                                    window.location.href = '/';
                                }
                                else {
                                    _this.postChatWork(toAmount, date, amount_hd, post_message).then(function () {
                                        console.log("chatworkにメッセージ送信完了");
                                        alert("送信成功しました。");
                                        window.location.href = '/';
                                    });
                                }
                            }
                            else {
                                console.log("送信エラー");
                                alert("送信エラー: " + sendRes.message);
                            }
                            console.log("リクエスト結果：\n" + sendRes.message);
                        }).catch(function (err) {
                            console.log('txErr:', err);
                            console.log("送信エラー");
                        });
                    }).catch(function (supplyErr) {
                        console.log('supplyErr:', supplyErr);
                    });
                }).catch(function (e) {
                    console.log('mosaicDefinitionsError:', e);
                });
                return [2 /*return*/];
            });
        });
    };
    // ローカルストレージから取得.
    mosaicTransfer.prototype.load = function () {
        return __awaiter(this, void 0, void 0, function () {
            var key, result, key2, result2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        key = 'SmartUQ-Wallet';
                        return [4 /*yield*/, localForage.getItem(key)];
                    case 1:
                        result = _a.sent();
                        if (result !== null) {
                            this.address = result.address;
                            this.privateKey = this.helper.Decrypt(result.privateKey);
                            this.publicKey = result.publicKey;
                        }
                        key2 = 'Company-Info';
                        return [4 /*yield*/, localForage.getItem(key2)];
                    case 2:
                        result2 = _a.sent();
                        if (!(result2 == null)) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.nem.getCompanyInfoFromAPI(this.address)];
                    case 3:
                        result2 = _a.sent();
                        _a.label = 4;
                    case 4: return [4 /*yield*/, this.setvar(result2)];
                    case 5:
                        _a.sent();
                        return [2 /*return*/, result];
                }
            });
        });
    };
    mosaicTransfer.prototype.setvar = function (result) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.yourMosaicName = result.mosaic_name;
                this.toAddress = result.address;
                console.log(result.address);
                console.log(result.mosaic_name);
                this.company_code = result.company_code;
                this.minimum_unit = result.minimum_unit;
                this.working_hour_per_day = result.working_hour_per_day;
                this.approval_flag = result.approval_flag;
                this.carry_over_flag = result.carry_over_flag;
                if (this.carry_over_flag == 1) {
                    this.show_kurikoshi = true;
                }
                else {
                    this.show_kurikoshi = false;
                }
                if (this.approval_flag == 1) {
                    this.approval = true;
                }
                else {
                    this.nonapproval = true;
                }
                return [2 /*return*/];
            });
        });
    };
    mosaicTransfer.prototype.postChatWork = function (toAmount, date, amount_hd, post_message) {
        return __awaiter(this, void 0, void 0, function () {
            var headers, access_token, uid, client, request, url, amount_date, message, request_url, params;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.log("in postchatwork");
                        return [4 /*yield*/, this.helper.loadHeaders()];
                    case 1:
                        headers = _a.sent();
                        access_token = headers["access-token"];
                        uid = headers["uid"];
                        client = headers["client"];
                        request = new XMLHttpRequest();
                        url = this.helper.path + "auth_users/send_massege/" + this.address + "?message=";
                        amount_date = "&amount=" + toAmount + "&date=" + date;
                        message = post_message;
                        request_url = url + message + amount_date;
                        console.log(request_url);
                        request.open('GET', request_url);
                        request.setRequestHeader("Content-Type", "application/json");
                        request.setRequestHeader("access-token", access_token);
                        request.setRequestHeader("uid", uid);
                        request.setRequestHeader("client", client);
                        request.onreadystatechange = function () {
                            if (request.readyState != 4) {
                                // リクエスト中
                            }
                            else if (request.status != 200) {
                                // 失敗
                            }
                            else {
                                // 取得成功
                                // var result = request.responseText;
                            }
                        };
                        request.send(null);
                        console.log('tapSend', message);
                        params = "/#/outputs?amount=" + toAmount + "&amount_hd=" + amount_hd + "&massege=" + post_message + "&date=" + date;
                        return [2 /*return*/];
                }
            });
        });
    };
    return mosaicTransfer;
}());
export default mosaicTransfer;



//////////////////
// WEBPACK FOOTER
// ./src/ts/mosaicTransfer.ts
// module id = 113
// module chunks = 1